import MobileNavigationAction from 'components/MobileMenu/MobileNavigationAction'
import { getAuthPageUrl } from 'utils/authorization'
import React from 'react';
import { Link } from 'react-router-dom';
import LoginIcon from 'components/IconAntDesign/LoginIcon';
import { Space } from 'antd';
import { useTranslation } from 'react-i18next'

const _Page_Header_User_Guest = ({ react_widget, mobile }) => {
  const { t } = useTranslation()
  if (mobile) return (
    <MobileNavigationAction as={react_widget ? 'a' : Link} variant="login"
      {...(react_widget ? { href: getAuthPageUrl() } : { to: getAuthPageUrl() })}
      data-testid="mobile-login">
      {t('Log in')}
    </MobileNavigationAction>
  )
  // TODO: после обновления react router dom просто использоваться <Link> с reloadDocument
  if (react_widget) {
    return (
      <a href={getAuthPageUrl()}>
        <Space style={{ alignItems: 'center' }}>
          <span>{t('Log in')}</span>
          <LoginIcon />
        </Space>
      </a>
    );
  }

  return (
    <Link to={getAuthPageUrl()}>
      <Space style={{ alignItems: 'center' }}>
        <span>{t('Log in')}</span>
        <LoginIcon />
      </Space>
    </Link>
  );
};

export default _Page_Header_User_Guest;
